import { LOGOUT_USER, ENV_CHANGE } from "../types/authTypes";
import {
  CREATE_RANKED_ROUND,
  UPDATE_RANKED_ROUND,
  DELETE_RANKED_ROUND,
  FETCH_RANKED_ROUND_SUBMISSIONS,
  UPDATE_LEADERBOARD,
  FETCH_RANKED_ROUNDS
} from "../types/competitionTypes";

const INITIAL_STATE = {
  rankedRounds: {
    data: [],
    pagination: {}
  },
  submissions: {
    data: {},
    pagination: {}
  },
  leaderboards: {
    data: {}
  }
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_RANKED_ROUND:
      return {
        ...state,
        rankedRounds: {
          ...state.rankedRounds,
          data: [action.payload, ...state.rankedRounds.data]
        }
      };
    
    case UPDATE_RANKED_ROUND:
      return {
        ...state,
        rankedRounds: {
          ...state.rankedRounds,
          data: state.rankedRounds.data.map(round => 
            round.id === action.payload.id ? action.payload : round
          )
        }
      };
    
    case DELETE_RANKED_ROUND:
      return {
        ...state,
        rankedRounds: {
          ...state.rankedRounds,
          data: state.rankedRounds.data.filter(round => round.id !== action.payload)
        }
      };
    
    case FETCH_RANKED_ROUND_SUBMISSIONS:
      return {
        ...state,
        submissions: {
          ...state.submissions,
          data: {
            ...state.submissions.data,
            [action.payload.round_id]: action.payload.data
          },
          pagination: {
            ...state.submissions.pagination,
            [action.payload.round_id]: action.payload.pagination
          }
        }
      };
    
    case UPDATE_LEADERBOARD:
      return {
        ...state,
        leaderboards: {
          ...state.leaderboards,
          data: {
            ...state.leaderboards.data,
            [action.payload.round_id]: action.payload.leaderboard
          }
        }
      };
    
    case FETCH_RANKED_ROUNDS:
      return {
        ...state,
        rankedRounds: {
          data: action.payload.data,
          pagination: action.payload.pagination
        }
      };
    
    case ENV_CHANGE:
    case LOGOUT_USER:
      return INITIAL_STATE;
    
    default:
      return state;
  }
};
